/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationMarker/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LocationMarker({
  children,
  viewPath = "/DesignSystem/Svgs/LocationMarker",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 7.3,
  height = 9.8,
  fill = "#1A1A1A"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="LocationMarker.Svg"
  data-view-path={viewPath}
 viewBox="0 0 7.3 9.8"
 overflow="visible"
 style={{'--as-1-Z1DJ8R3': alignSelf,'--mt-2-Z1DJ8R3': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1DJ8R3': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1DJ8R3': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1DJ8R3': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1DJ8R3': opacity,'--w-7-Z1DJ8R3': typeof width === 'number' ? `${width}px` : width,'--h-8-Z1DJ8R3': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="LocationMarker.SvgPath"
  data-view-path={viewPath}
 d="M3.7 0C1.6 0 0 1.6 0 3.7c0 1.8 3 5.4 3.6 6.1 0 0 .1.1.2 0 .6-.6 3.6-4.2 3.6-6.1C7.3 1.6 5.7 0 3.7 0z"
 style={{'--f-9-Z1DJ8R3': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}